import { gql } from "gql";

export const GET_DYNAMIC_PROCESS_BY_ID = gql(/* GraphQL */ `
  query GetDynamicProcessById($id: ID!) {
    getDynamicProcessById(id: $id) {
      ... on DynamicModelDefinitionDto {
        id
        name {
          ...LocalizedValueDtoFragment
        }
        icon {
          id
        }
        allowAttachments
        active
        route {
          ...EditPathInputData
        }
        initiatorNotificationTemplate {
          value {
            ...EditNotificationTemplate
          }
        }

        approverNotificationTemplate {
          value {
            ...EditNotificationTemplate
          }
        }
      }
    }
  }
`);
